import { ChangeDetectionStrategy, Component, ElementRef, Injector, NgModule, Renderer2, ViewContainerRef } from '@angular/core';
import { ComponentBase, ComponentMixins, setValue } from '@syncfusion/ej2-angular-base';
import { BarcodeGenerator, DataMatrixGenerator, QRCodeGenerator } from '@syncfusion/ej2-barcode-generator';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const inputs = ['backgroundColor', 'displayText', 'enableCheckSum', 'enablePersistence', 'enableRtl', 'foreColor', 'height', 'locale', 'margin', 'mode', 'type', 'value', 'width'];
const outputs = ['invalid'];
const twoWays = [''];
/**
 * Barcode Component
 * ```html
 * <ej-barcode-generator></ej-barcode-generator>
 * ```
 */
let BarcodeGeneratorComponent = class BarcodeGeneratorComponent extends BarcodeGenerator {
    /**
     * @param {?} ngEle
     * @param {?} srenderer
     * @param {?} viewContainerRef
     * @param {?} injector
     */
    constructor(ngEle, srenderer, viewContainerRef, injector) {
        super();
        this.ngEle = ngEle;
        this.srenderer = srenderer;
        this.viewContainerRef = viewContainerRef;
        this.injector = injector;
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];
        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.context = new ComponentBase();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.context.ngOnInit(this);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.context.ngAfterViewInit(this);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.context.ngOnDestroy(this);
    }
    /**
     * @return {?}
     */
    ngAfterContentChecked() {
        this.context.ngAfterContentChecked(this);
    }
};
BarcodeGeneratorComponent.ɵfac = function BarcodeGeneratorComponent_Factory(t) { return new (t || BarcodeGeneratorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
BarcodeGeneratorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BarcodeGeneratorComponent, selectors: [["ejs-barcodegenerator"]], inputs: { backgroundColor: "backgroundColor", displayText: "displayText", enableCheckSum: "enableCheckSum", enablePersistence: "enablePersistence", enableRtl: "enableRtl", foreColor: "foreColor", height: "height", locale: "locale", margin: "margin", mode: "mode", type: "type", value: "value", width: "width" }, outputs: { invalid: "invalid" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function BarcodeGeneratorComponent_Template(rf, ctx) { }, encapsulation: 2, changeDetection: 0 });
/**
 * @nocollapse
 */
BarcodeGeneratorComponent.ctorParameters = () => [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: ViewContainerRef, },
    { type: Injector, },
];
BarcodeGeneratorComponent = __decorate([
    ComponentMixins([ComponentBase]),
    __metadata("design:paramtypes", [ElementRef,
        Renderer2,
        ViewContainerRef,
        Injector])
], BarcodeGeneratorComponent);

/**
 * NgModule definition for the BarcodeGenerator component.
 */
class BarcodeGeneratorModule {
}
BarcodeGeneratorModule.ɵfac = function BarcodeGeneratorModule_Factory(t) { return new (t || BarcodeGeneratorModule)(); };
BarcodeGeneratorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BarcodeGeneratorModule });
BarcodeGeneratorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
/**
 * @nocollapse
 */
BarcodeGeneratorModule.ctorParameters = () => [];

/**
 * NgModule definition for the BarcodeGenerator component with providers.
 */
class BarcodeGeneratorAllModule {
}
BarcodeGeneratorAllModule.ɵfac = function BarcodeGeneratorAllModule_Factory(t) { return new (t || BarcodeGeneratorAllModule)(); };
BarcodeGeneratorAllModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BarcodeGeneratorAllModule });
BarcodeGeneratorAllModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, BarcodeGeneratorModule], BarcodeGeneratorModule] });
/**
 * @nocollapse
 */
BarcodeGeneratorAllModule.ctorParameters = () => [];

var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const inputs$1 = ['backgroundColor', 'displayText', 'enablePersistence', 'enableRtl', 'errorCorrectionLevel', 'foreColor', 'height', 'locale', 'margin', 'mode', 'value', 'version', 'width', 'xDimension'];
const outputs$1 = ['invalid'];
const twoWays$1 = [''];
/**
 * QRCode Component
 * ```html
 * <ej-qrcode-generator></ej-qrcode-generator>
 * ```
 */
let QRCodeGeneratorComponent = class QRCodeGeneratorComponent extends QRCodeGenerator {
    /**
     * @param {?} ngEle
     * @param {?} srenderer
     * @param {?} viewContainerRef
     * @param {?} injector
     */
    constructor(ngEle, srenderer, viewContainerRef, injector) {
        super();
        this.ngEle = ngEle;
        this.srenderer = srenderer;
        this.viewContainerRef = viewContainerRef;
        this.injector = injector;
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];
        this.registerEvents(outputs$1);
        this.addTwoWay.call(this, twoWays$1);
        setValue('currentInstance', this, this.viewContainerRef);
        this.context = new ComponentBase();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.context.ngOnInit(this);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.context.ngAfterViewInit(this);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.context.ngOnDestroy(this);
    }
    /**
     * @return {?}
     */
    ngAfterContentChecked() {
        this.context.ngAfterContentChecked(this);
    }
};
QRCodeGeneratorComponent.ɵfac = function QRCodeGeneratorComponent_Factory(t) { return new (t || QRCodeGeneratorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
QRCodeGeneratorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: QRCodeGeneratorComponent, selectors: [["ejs-qrcodegenerator"]], inputs: { backgroundColor: "backgroundColor", displayText: "displayText", enablePersistence: "enablePersistence", enableRtl: "enableRtl", errorCorrectionLevel: "errorCorrectionLevel", foreColor: "foreColor", height: "height", locale: "locale", margin: "margin", mode: "mode", value: "value", version: "version", width: "width", xDimension: "xDimension" }, outputs: { invalid: "invalid" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function QRCodeGeneratorComponent_Template(rf, ctx) { }, encapsulation: 2, changeDetection: 0 });
/**
 * @nocollapse
 */
QRCodeGeneratorComponent.ctorParameters = () => [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: ViewContainerRef, },
    { type: Injector, },
];
QRCodeGeneratorComponent = __decorate$1([
    ComponentMixins([ComponentBase]),
    __metadata$1("design:paramtypes", [ElementRef,
        Renderer2,
        ViewContainerRef,
        Injector])
], QRCodeGeneratorComponent);

/**
 * NgModule definition for the QRCodeGenerator component.
 */
class QRCodeGeneratorModule {
}
QRCodeGeneratorModule.ɵfac = function QRCodeGeneratorModule_Factory(t) { return new (t || QRCodeGeneratorModule)(); };
QRCodeGeneratorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: QRCodeGeneratorModule });
QRCodeGeneratorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
/**
 * @nocollapse
 */
QRCodeGeneratorModule.ctorParameters = () => [];

/**
 * NgModule definition for the QRCodeGenerator component with providers.
 */
class QRCodeGeneratorAllModule {
}
QRCodeGeneratorAllModule.ɵfac = function QRCodeGeneratorAllModule_Factory(t) { return new (t || QRCodeGeneratorAllModule)(); };
QRCodeGeneratorAllModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: QRCodeGeneratorAllModule });
QRCodeGeneratorAllModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, QRCodeGeneratorModule], QRCodeGeneratorModule] });
/**
 * @nocollapse
 */
QRCodeGeneratorAllModule.ctorParameters = () => [];

var __decorate$2 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$2 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const inputs$2 = ['backgroundColor', 'displayText', 'enablePersistence', 'enableRtl', 'encoding', 'foreColor', 'height', 'locale', 'margin', 'mode', 'size', 'value', 'width', 'xDimension'];
const outputs$2 = ['invalid'];
const twoWays$2 = [''];
/**
 * DataMatrix Component
 * ```html
 * <ej-datamatrix-generator></ej-datamatrix-generator>
 * ```
 */
let DataMatrixGeneratorComponent = class DataMatrixGeneratorComponent extends DataMatrixGenerator {
    /**
     * @param {?} ngEle
     * @param {?} srenderer
     * @param {?} viewContainerRef
     * @param {?} injector
     */
    constructor(ngEle, srenderer, viewContainerRef, injector) {
        super();
        this.ngEle = ngEle;
        this.srenderer = srenderer;
        this.viewContainerRef = viewContainerRef;
        this.injector = injector;
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];
        this.registerEvents(outputs$2);
        this.addTwoWay.call(this, twoWays$2);
        setValue('currentInstance', this, this.viewContainerRef);
        this.context = new ComponentBase();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.context.ngOnInit(this);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.context.ngAfterViewInit(this);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.context.ngOnDestroy(this);
    }
    /**
     * @return {?}
     */
    ngAfterContentChecked() {
        this.context.ngAfterContentChecked(this);
    }
};
DataMatrixGeneratorComponent.ɵfac = function DataMatrixGeneratorComponent_Factory(t) { return new (t || DataMatrixGeneratorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
DataMatrixGeneratorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DataMatrixGeneratorComponent, selectors: [["ejs-datamatrixgenerator"]], inputs: { backgroundColor: "backgroundColor", displayText: "displayText", enablePersistence: "enablePersistence", enableRtl: "enableRtl", encoding: "encoding", foreColor: "foreColor", height: "height", locale: "locale", margin: "margin", mode: "mode", size: "size", value: "value", width: "width", xDimension: "xDimension" }, outputs: { invalid: "invalid" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DataMatrixGeneratorComponent_Template(rf, ctx) { }, encapsulation: 2, changeDetection: 0 });
/**
 * @nocollapse
 */
DataMatrixGeneratorComponent.ctorParameters = () => [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: ViewContainerRef, },
    { type: Injector, },
];
DataMatrixGeneratorComponent = __decorate$2([
    ComponentMixins([ComponentBase]),
    __metadata$2("design:paramtypes", [ElementRef,
        Renderer2,
        ViewContainerRef,
        Injector])
], DataMatrixGeneratorComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BarcodeGeneratorComponent, [{
        type: Component,
        args: [{
                selector: 'ejs-barcodegenerator',
                inputs: inputs,
                outputs: outputs,
                template: '',
                changeDetection: ChangeDetectionStrategy.OnPush,
                queries: {}
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.Injector }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BarcodeGeneratorModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    BarcodeGeneratorComponent
                ],
                exports: [
                    BarcodeGeneratorComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BarcodeGeneratorModule, { declarations: function () { return [BarcodeGeneratorComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BarcodeGeneratorComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BarcodeGeneratorAllModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, BarcodeGeneratorModule],
                exports: [
                    BarcodeGeneratorModule
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BarcodeGeneratorAllModule, { imports: function () { return [CommonModule, BarcodeGeneratorModule]; }, exports: function () { return [BarcodeGeneratorModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QRCodeGeneratorComponent, [{
        type: Component,
        args: [{
                selector: 'ejs-qrcodegenerator',
                inputs: inputs$1,
                outputs: outputs$1,
                template: '',
                changeDetection: ChangeDetectionStrategy.OnPush,
                queries: {}
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.Injector }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QRCodeGeneratorModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    QRCodeGeneratorComponent
                ],
                exports: [
                    QRCodeGeneratorComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(QRCodeGeneratorModule, { declarations: function () { return [QRCodeGeneratorComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [QRCodeGeneratorComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QRCodeGeneratorAllModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, QRCodeGeneratorModule],
                exports: [
                    QRCodeGeneratorModule
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(QRCodeGeneratorAllModule, { imports: function () { return [CommonModule, QRCodeGeneratorModule]; }, exports: function () { return [QRCodeGeneratorModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataMatrixGeneratorComponent, [{
        type: Component,
        args: [{
                selector: 'ejs-datamatrixgenerator',
                inputs: inputs$2,
                outputs: outputs$2,
                template: '',
                changeDetection: ChangeDetectionStrategy.OnPush,
                queries: {}
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.Injector }]; }, null); })();

/**
 * NgModule definition for the DataMatrixGenerator component.
 */
class DataMatrixGeneratorModule {
}
DataMatrixGeneratorModule.ɵfac = function DataMatrixGeneratorModule_Factory(t) { return new (t || DataMatrixGeneratorModule)(); };
DataMatrixGeneratorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DataMatrixGeneratorModule });
DataMatrixGeneratorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
/**
 * @nocollapse
 */
DataMatrixGeneratorModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataMatrixGeneratorModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    DataMatrixGeneratorComponent
                ],
                exports: [
                    DataMatrixGeneratorComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DataMatrixGeneratorModule, { declarations: function () { return [DataMatrixGeneratorComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DataMatrixGeneratorComponent]; } }); })();

/**
 * NgModule definition for the DataMatrixGenerator component with providers.
 */
class DataMatrixGeneratorAllModule {
}
DataMatrixGeneratorAllModule.ɵfac = function DataMatrixGeneratorAllModule_Factory(t) { return new (t || DataMatrixGeneratorAllModule)(); };
DataMatrixGeneratorAllModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DataMatrixGeneratorAllModule });
DataMatrixGeneratorAllModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, DataMatrixGeneratorModule], DataMatrixGeneratorModule] });
/**
 * @nocollapse
 */
DataMatrixGeneratorAllModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataMatrixGeneratorAllModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, DataMatrixGeneratorModule],
                exports: [
                    DataMatrixGeneratorModule
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DataMatrixGeneratorAllModule, { imports: function () { return [CommonModule, DataMatrixGeneratorModule]; }, exports: function () { return [DataMatrixGeneratorModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BarcodeGeneratorComponent, BarcodeGeneratorModule, BarcodeGeneratorAllModule, QRCodeGeneratorComponent, QRCodeGeneratorModule, QRCodeGeneratorAllModule, DataMatrixGeneratorComponent, DataMatrixGeneratorModule, DataMatrixGeneratorAllModule, inputs as ɵa, outputs as ɵb, inputs$2 as ɵe, outputs$2 as ɵf, inputs$1 as ɵc, outputs$1 as ɵd };
export { BarcodeGenerator, BarcodeBase, OneDimension, BarcodeEvent, QuietZone, DataMatrixSize, QRCodeVersion, ErrorCorrectionLevel, createHtmlElement, getChildNode, measureText, setAttribute, createSvgElement, createMeasureElements, Point, Rect, Size, DisplayText, Margin, BarcodeCanvasRenderer, BarcodeRenderer, BarcodeSVGRenderer, CodaBar, Code128, Code128A, Code128B, Code128C, Code39, Ean8, Ean13, UpcA, UpcE, QRCode, ModuleValue, QRCodeGenerator, PdfQRBarcodeValues, ErrorCorrectionCodewords, DataMatrixGenerator, DataMatrix } from '@syncfusion/ej2-barcode-generator';

